export default __webpack_public_path__ + "static/media/el2.3be11507.jpeg";